import axios from '@/api/requests/axios'

export default {
  getAll: params => axios.get('/api/admin/v1/webhooks', { params }),

  getById: id => axios
    .get(`/api/admin/v1/webhooks/${id}`, {
      validateStatus: status => (status >= 200 && status < 300) || status === 404,
    })
    .then(response => (response.status === 404
      ? Promise.reject(Object.assign(new Error('webhook is not found'), { response }))
      : response)),
}
